module.exports = __webpack_public_path__ + "media/dashboard/assets/images/Patern_sombra-dfa70043dcd0bb4e011d05d358baa108.svg";